var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaulPicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H94C97.3137 0 100 2.68629 100 6V94C100 97.3137 97.3137 100 94 100H6C2.68629 100 0 97.3137 0 94V6Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6667 60H44.3682C43.6951 60 43.3585 60 43.2027 59.8669C43.0674 59.7514 42.9957 59.5781 43.0096 59.4009C43.0257 59.1965 43.2637 58.9585 43.7396 58.4826L53.1874 49.0349C53.6274 48.5948 53.8474 48.3748 54.1011 48.2924C54.3243 48.2199 54.5646 48.2199 54.7878 48.2924C55.0415 48.3748 55.2615 48.5948 55.7015 49.0349L60 53.3333V54.6667M54.6667 60C56.5335 60 57.4669 60 58.18 59.6367C58.8072 59.3171 59.3171 58.8072 59.6367 58.18C60 57.4669 60 56.5335 60 54.6667M54.6667 60H45.3333C43.4665 60 42.5331 60 41.82 59.6367C41.1928 59.3171 40.6829 58.8072 40.3633 58.18C40 57.4669 40 56.5335 40 54.6667V45.3333C40 43.4665 40 42.5331 40.3633 41.82C40.6829 41.1928 41.1928 40.6829 41.82 40.3633C42.5331 40 43.4665 40 45.3333 40H54.6667C56.5335 40 57.4669 40 58.18 40.3633C58.8072 40.6829 59.3171 41.1928 59.6367 41.82C60 42.5331 60 43.4665 60 45.3333V54.6667M48.3333 46.1111C48.3333 47.3384 47.3384 48.3333 46.1111 48.3333C44.8838 48.3333 43.8889 47.3384 43.8889 46.1111C43.8889 44.8838 44.8838 43.8889 46.1111 43.8889C47.3384 43.8889 48.3333 44.8838 48.3333 46.1111Z",
    stroke: "#596575",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaulPicture);
export default __webpack_public_path__ + "static/media/defaulPicture.0254aeaeb10a232e30e7072b79dc6471.svg";
export { ForwardRef as ReactComponent };